// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__post[data-v-3ac3f78c]{max-width:910px;margin:auto}.card__post-denied[data-v-3ac3f78c]{border:1px solid #f83245;background-color:#fff5f6}", ""]);
// Exports
module.exports = exports;
